import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';
import { SoftNav } from '@newrelic/browser-agent/features/soft_navigations';
import { GenericEvents } from '@newrelic/browser-agent/features/generic_events';

const CLEAR_PIP_VIEW_EXTENSION_ORIGIN = 'chrome-extension://dcmdiknbnpjcbecpfpipeadobeldbijh/';

const isClearPipViewExtensionError = (error) =>
    typeof error !== 'string' && error?.stack?.includes(CLEAR_PIP_VIEW_EXTENSION_ORIGIN) === true;

class NewRelicLoader {
    constructor() {
        this.required = {
            licenseKey: process.env.VUE_APP_NEW_RELIC_BROWSER_LICENSE_KEY,
            applicationId: process.env.VUE_APP_NEW_RELIC_BROWSER_APPLICATION_ID,
            accountId: process.env.VUE_APP_NEW_RELIC_BROWSER_ACCOUNT_ID,
            agentId: process.env.VUE_APP_NEW_RELIC_BROWSER_AGENT_ID,
        };

        this.optional = {
            trustKey: process.env.VUE_APP_NEW_RELIC_BROWSER_TRUST_KEY,
            beacon: process.env.VUE_APP_NEW_RELIC_BROWSER_BEACON,
            errorBeacon: process.env.VUE_APP_NEW_RELIC_BROWSER_ERROR_BEACON,
        };

        this.agent = null;
    }

    hasRequired() {
        const { licenseKey, applicationId, accountId, agentId } = this.required;
        return Boolean(licenseKey && applicationId && accountId && agentId);
    }

    init() {
        if (!this.hasRequired() || this.agent) {
            return;
        }

        const trustKey = this.optional.trustKey || this.required.accountId;
        const beacon = this.optional.beacon || 'bam.nr-data.net';
        const errorBeacon = this.optional.errorBeacon || beacon;

        const options = {
            init: {
                privacy: { cookies_enabled: true },
                performance: {
                    capture_marks: false,
                    capture_measures: true,
                    capture_detail: false,
                },
                ajax: {
                    deny_list: ['token=', 'access_token=', 'graph.facebook.com', 'niotext'],
                },
            },
            loader_config: {
                accountID: this.required.accountId,
                trustKey,
                agentID: this.required.agentId,
                licenseKey: this.required.licenseKey,
                applicationID: this.required.applicationId,
            },
            info: {
                beacon,
                errorBeacon,
                licenseKey: this.required.licenseKey,
                applicationID: this.required.applicationId,
                sa: 1,
            },
            features: [SoftNav, GenericEvents],
        };

        this.agent = new BrowserAgent(options);
        this.agent.setErrorHandler(isClearPipViewExtensionError);
    }

    getAgent() {
        return this.agent;
    }
}

const newRelicLoader = new NewRelicLoader();
newRelicLoader.init();

export default newRelicLoader;
